export default __webpack_public_path__ + "static/media/nike_air_logo.472111fa.png";